/**
 * Formats a number with a fixed number of decimals, grouped per the given locale
 * (BCP-47, e.g. `fr` → space grouping + comma decimal, `en` → comma grouping +
 * dot decimal). Generic and reusable across features — never hardcodes a locale.
 *
 * @param value          the number to format
 * @param locale         BCP-47 language tag (the selected UI language)
 * @param fractionDigits fixed number of decimals (default 2)
 */
export function formatDecimal(value: number, locale: string, fractionDigits = 2): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}
